import http from "./http";

export function listResource(api, params) {
  return http.get(`/${api}`, { params });
}

export function createResource(api, data) {
  return http.post(`/${api}`, data);
}

export function updateResource(api, id, data) {
  return http.put(`/${api}/${id}`, data);
}

export function deleteResource(api, id) {
  return http.delete(`/${api}/${id}`);
}

export function changeResourceStatus(api, id, status) {
  return http.patch(`/${api}/${id}/status`, { status });
}

export function uploadAsset(file, extra = {}) {
  const form = new FormData();
  form.append("file", file);
  Object.keys(extra).forEach((key) => form.append(key, extra[key]));
  return http.post("/assets/upload", form, {
    headers: { "Content-Type": "multipart/form-data" }
  });
}
